module.exports = __webpack_public_path__ + "img/notfound-code.fea78d58.png";